<div class="modal-header">
    <h4 class="modal-title">{{ 'EXPORT_VISIT_LIST' | translate }}</h4>
    <button type="button" class="close" (click)="dismissModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div class="container-flex">
        <div class="row pb-3">
            <label class="col-xs-2" for="select-employee-dropdown">{{ 'SELECT_EMPLOYEE' | translate }}</label>
            <app-dropdown
                id="select-employee-dropdown"
                class="col-xs-3"
                [closeOnScroll]="false"
                [items]="employeeDropdownItems"
                [(ngModel)]="selectedEmployeeWorkHourId"
                (change)="reloadPreview()"
                data-qa="qa-select-employee-dropdown"
            ></app-dropdown>
        </div>
        @if (mapsEnabled$ | async) {
            <div class="row pb-3">
                <label class="col-xs-2" for="includeMap">{{ 'INCLUDE_MAPS' | translate }}</label>
                <app-toggle
                    class="col-xs-3"
                    id="includeMap"
                    [large]="true"
                    [(ngModel)]="includeMap"
                    (change)="reloadPreview()"
                ></app-toggle>
            </div>
        }
        <ngx-extended-pdf-viewer
            class="flex-1"
            [src]="pdfData"
            [showSidebarButton]="false"
            [showDownloadButton]="false"
            [showFindButton]="false"
            [showOpenFileButton]="false"
            [showPropertiesButton]="false"
            [showSecondaryToolbarButton]="false"
            [zoom]="125"
            useBrowserLocale="true"
            (pagesLoaded)="pdfViewerPagesLoaded($event)"
        ></ngx-extended-pdf-viewer>
    </div>
    <div class="pdf-content">
        @for (employee of employees$ | async; track employee; let last = $last; let i = $index) {
            @if (selectedEmployeeWorkHourId === DefaultSelectedValue ||
            selectedEmployeeWorkHourId === employee.workHourId) {
                <div id="page-{{i}}">
                    <div class="header d-inline-flex w-100 justify-content-between">
                        <span class="vismaicon icon-route"></span>
                        <div class="export-date">{{ planDate }}</div>
                    </div>
                    <app-employee-route-info [employee]="employee" [includeMap]="includeMap"
                                             [routeSolution]="routeSolution">
                    </app-employee-route-info>
                    @if (selectedEmployeeWorkHourId === DefaultSelectedValue && !last) {
                        <span></span>
                    }
                </div>
            }
        }
        <div id="page-{{totalPageCount}}">
            <app-route-planning-unallocated-tasks
                class="h-100 unallocated-tasks"
                [unallocatedTasks]="nonAllocatedTasksInfo"
                [pdfView]="true"
            ></app-route-planning-unallocated-tasks>
        </div>
        <div class="footer w-100 mw-100 d-flex justify-content-center" id="footer">
            <img class="mx-auto my-2"
                 ngSrc="/assets/images/visma-logo.svg" alt="Visma" width="100" height="20"/>
        </div>
    </div>
    @if (loading) {
        <span class="spinner spinner-lg absolute-centering"></span>
    }
</div>
<div class="modal-footer">
    <div class="right-container">
        <button type="button" id="secondary" class="btn btn-secondary" (click)="dismissModal()">
            {{ 'CANCEL' | translate }}
        </button>
        <button type="button" id="primary" class="btn btn-primary" [disabled]="loading" (click)="print()">
            {{ 'PRINT' | translate }}
        </button>
    </div>
</div>
